import React from 'react';
import SecureComponent from '../SecureComponent';
import { connect } from 'react-redux';
import * as types from 'constants/actionTypes';
import { TextField } from '@mui/material';
import { toMoney, toMoneyTyping } from 'library/moneyUtils';

class DecimalInputReceiveProduct extends SecureComponent {
    constructor(props) {
        super(props);
        if (props.value) //if store has value relative to this component, initialize the state value
            this.state = { ...this.state, value: props.value, error: "" };
        else //in case the store does not have any value for this component, just clear it
            this.state = { ...this.state, value: "", error: "" };
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value && newProps.value !== this.state.value)//if store's value relative to this component change, update the state value
            this.setState({ value: newProps.value });
        else if (!newProps.value)//in case the store does not have any value for this component, just clear it
            this.setState({ value: "" });

        if (newProps.error && newProps.error !== this.state.error)
            this.setState({ error: newProps.error });
    }

    onChange = (event) => {
        const value = event.target.value;
        const maskedStringValue = toMoneyTyping(value);
        const floatValue = parseFloat(maskedStringValue.replace(new RegExp(',', 'g'), ''));//.replace(',', ''));
        const min = parseFloat(this.props.min || 0);
        const max = parseFloat(this.props.max || 0);
        let finalFloatValue = floatValue;

        if (this.props.min !== undefined && floatValue <= min) {
            finalFloatValue = min
        }
        if (this.props.max !== undefined && floatValue >= max) {
            finalFloatValue = max;
        }

        const finalMaskedStringValue = toMoneyTyping(Math.round(finalFloatValue * 100 * 100) / 100);

        this.setState({ value: finalMaskedStringValue });
        this.updateStore(finalMaskedStringValue);
    }

    onBlur = (event) => {
        this.updateStore(event.target.value);
    }

    updateStore(value) {
        const error = this.validate(value);
        this.setState({ value, error });
        this.props.dispatch({ type: types.FORM_INPUT, value: value.replace(new RegExp(',', 'g'), ''), name: this.props.name });
        if (this.props.name == "receivedQuantityDialogMargin") {
            this.props.dispatch({ type: types.FORM_INPUT, value: (this.props.receivedQuantityDialogUnitPrice / (1 - value.replace(new RegExp(',', 'g'), '') / 100)).toFixed(2), name: "receivedQuantityDialogSalePrice" });
            this.props.dispatch({ type: types.FORM_INPUT, value: (this.props.receivedQuantityDialogUnitPrice / (1 - value.replace(new RegExp(',', 'g'), '') / 100)).toFixed(2), name: "receivedQuantityDialogMemberSalePrice" });
        }
        if (this.props.name == "receivedQuantityDialogSalePrice") {
            this.props.dispatch({ type: types.FORM_INPUT, value: ((value.replace(new RegExp(',', 'g'), '') - this.props.receivedQuantityDialogUnitPrice) / value.replace(new RegExp(',', 'g'), '') * 100).toFixed(2), name: "receivedQuantityDialogMargin" });
            this.props.dispatch({ type: types.FORM_INPUT, value: value.replace(new RegExp(',', 'g'), ''), name: "receivedQuantityDialogMemberSalePrice" });
        }
    }

    validate(value) {
        const p = this.props;
        let error = null;
        if (!value && p.required)
            error = p.errorMsg ? p.errorMsg : p.name + ' is required';
        if (value && p.pattern) {
            let patt = new RegExp(p.pattern);
            if (!patt.test(value))
                error = p.patternErrorMsg ? p.patternErrorMsg : p.name + ' is invalid';
        }
        return error;
    }

    render() {
        const p = this.props;
        const value = this.state && this.state.value;
        const s = this.state;
        const showError = this.props.error && (value === '' || (!isNaN(value) && parseFloat(value) === 0));

        if (!s.authorized) return null;
        return (
            <div className={p.containerName || "form-group"}>
                <TextField
                    autoFocus={p.autoFocus}
                    name={p.name}
                    disabled={p.disabled}
                    underlineShow={p.underlineShow}
                    hintText={p.hintText}
                    errorText={showError ? p.error : ''}
                    value={toMoney(s.value)}
                    inputStyle={p.inputStyle}
                    hintStyle={p.hintStyle}
                    label={p.label || p.floatingLabelText}
                    InputProps={{ style: p.inputStyle }}
                    InputLabelProps={{ style: p.floatingLabelStyle }}
                    ref={p.ref}
                    fullWidth={p.fullWidth || false}
                    className={p.className}
                    onChange={(e) => this.onChange(e)}
                    onBlur={(e) => this.onBlur(e)} />
                {p.hasWarning ? p.warning : null}
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        value: state.form[props.name],
        error: state.form && state.form.error && state.form.error[props.name],
        userAutorizationLevel: state.common && state.common.user && state.common.user.authorizationLevel,
        poproductQuantity: state.form ? state.form["productPOQuantity"] ? state.form["productPOQuantity"] : 1 : 1,
        receivedQuantityDialogUnitPrice: state.form["receivedQuantityDialogUnitPrice"],
        receivedQuantityDialogMargin: state.form["receivedQuantityDialogMargin"],
        receivedQuantityDialogSalePrice: state.form["receivedQuantityDialogSalePrice"]
    };
};

export default connect(mapStateToProps)(DecimalInputReceiveProduct);
